import request from "@/utils/request"

// 获取追溯详细
export const getTraceDetailed = async (code) => {
  let res = await request.get(`/trace/${code}`)
  return res
}

